import { Directive, TemplateRef } from '@angular/core';
import { DatalistItemHeaderComponent } from './datalist-item-header.component';

@Directive({ selector: '[mriDatalistTitleTemplate]', standalone: true })
export class DatalistItemTitleTemplateDirective {
  constructor(itemTemplate: TemplateRef<HTMLElement>, datalist: DatalistItemHeaderComponent) {
    datalist.customTitleTemplate = itemTemplate;
  }
}
